import { render } from "./BreadcrumbContent.vue?vue&type=template&id=6d5ecc39"
import script from "./BreadcrumbContent.vue?vue&type=script&lang=js"
export * from "./BreadcrumbContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__